<template>
  <Card>
    <Tree :data="menuArr" show-checkbox @on-check-change="selectedMenuArr" ref="menuTree"></Tree>
    <Row style="margin-top:20px">
      <Button type="primary" style="margin-right:10px" @click.native="submitRoleMenu">提交</Button>
      <Button @click.native="handleChangePermissions(false)">取消</Button>
    </Row>
  </Card>
</template>

<script>
import { getMenu, updateRole } from '@/api/user'
export default {
  name: 'role-menu-manage',
  data () {
    return {
      menuArr: [],
      menuSelectedArr: []
    }
  },
  props: {
    'role_id': Number,
    'menus': Array,
    'handleChangePermissions': { type: Function }
  },
  methods: {
    selectedMenuArr () {
      let data = this.$refs.menuTree.getCheckedAndIndeterminateNodes()
      let len = data.length
      this.menuSelectedArr = []
      for (let i = 0; i < len; i++) {
        this.menuSelectedArr.push(data[i].id)
      }
      this.menuSelectedArr = Array.from(new Set(this.menuSelectedArr))
    },
    toTree (data) {
      // 删除 所有 children,以防止多次调用
      data.forEach(function (item) {
        delete item.children
      })
      // 将数据存储为 以 id 为 KEY 的 map 索引数据列
      var map = {}
      data.forEach(function (item) {
        map[item.id] = item
      })
      var val = []
      data.forEach(function (item) {
        // 以当前遍历项，的pid,去map对象中找到索引的id
        var parent = map[item.parent]
        // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
        if (parent) {
          (parent.children || (parent.children = [])).push(item)
        } else {
          // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
          val.push(item)
        }
      })
      return val
    },
    getMenuTree () {
      getMenu().then(res => {
        let arr = res.data
        for (let i = 0; i < arr.length; i++) {
          arr[i]['expand'] = false
        }
        arr = this.toTree(arr)
        this.menuArr = arr
      })
    },
    submitRoleMenu () {
      if (this.role_id) {
        if (!this.menuSelectedArr.length) {
          this.$Notice.warn({
            title: '请至少选择一个菜单项',
            desc: '角色菜单项不能为空'
          })
          return false
        }
        updateRole({ menu: this.menuSelectedArr }, this.role_id).then(res => {
          if (res.status === 200) {
            this.$Notice.success({ title: '操作成功！' })
            this.handleChangePermissions(false)
          } else {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      } else {
        this.$Message.error('角色未获取')
      }
    },
    retrieve () {
      getMenu().then(res => {
        let arr = res.data
        arr = this.toTree(arr)
        const checkNode = (list) => {
          return list.map(item => {
            if (item.children && item.children.length) {
              return checkNode(item.children)
            } else if (this.menus.indexOf(item['id']) !== -1) {
              item['checked'] = true
            }
          })
        }
        checkNode(arr)
        this.menuArr = arr
      })
    }
  },
  mounted () {
    this.getMenuTree()
    // console.log(this.menus)
  },
  watch: {
    menus () {
      this.retrieve()
    }
  }
}
</script>

<style scoped>

</style>
